import { css } from '@bts-web/utils-style-engine';
import { initServerTranslation, Language } from '@bts-web/utils-lokalise';
import { HyperLinkButtonBase } from '../../common/components/HyperLinkButtonBase/HyperLinkButtonBase';
import { InfoLayout } from '../../common/layout/InfoLayout/InfoLayout';
import { PoweredByTextWithLogo } from '../../trade/Reusable/PoweredBy/PoweredBy';
import { getAppConfig } from '@bts-web/core-app-config';

export interface LogoutPageProps {
  searchParams: Promise<Record<string, string>>;
}

const LogoutPage = async ({ searchParams }: LogoutPageProps) => {
  const { auto, lang, isIslamicUser } = await searchParams;

  const { t } = await initServerTranslation(
    lang ? (lang.toLocaleLowerCase() as Language) : undefined,
  );

  const { infoLayoutTextVariant } = getAppConfig();

  const loginUrl = process.env.NEXT_PUBLIC_APP_LOGIN_URL;

  const isAutoLogout = parseInt(auto) === 1;

  const isIslamic = parseInt(isIslamicUser) === 1;

  const title = isAutoLogout
    ? t('autologout_success_title')
    : t('logout_success_title');

  const subtitle = isAutoLogout
    ? t('autologout_success_subtitle')
    : t('logout_success_subtitle');

  return (
    <InfoLayout
      mainHeadingFirstLine={title}
      description={subtitle}
      isIslamicUser={isIslamic}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'large',
          mt: 'auto',
          pb: 'medium',
        })}
      >
        <PoweredByTextWithLogo
          inverted={infoLayoutTextVariant === 'inverted'}
          value={t('powered_by_@tenant')}
        />

        {loginUrl && (
          <HyperLinkButtonBase to={loginUrl as string}>
            {t('continue')}
          </HyperLinkButtonBase>
        )}
      </div>
    </InfoLayout>
  );
};

export { LogoutPage };
